import AccountSettingsForm from "../../components/Settings/AccountSettingsForm";
import NavSettings from "../../components/common/NavSettings";

const AccountSettings = () => {
  return (
    <>
      <NavSettings title="Mi perfil" route="Inicio" active="Perfil" />

      <AccountSettingsForm />
    </>
  );
};

export default AccountSettings;
